import { httpClient } from '@/modules/common/services/http/http-client';
import { IFaq } from './types';

const baseURL = `/api/v1/faq/`;

export function getFaq(type: string): Promise<IFaq> {
  return httpClient.get(`${baseURL}${type}`);
}
